import React, { useState, useEffect } from 'react';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldText from '../../../../../components/FieldText/FieldText';
import FieldCheck from '../../../../../components/FieldCheck/FieldCheck';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import { API } from '../../../../../API/API';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';

const ExtraTypeNew = (props) => {

    const [initData, setInitData] = useState({
        "extratypeid": -1,
        "name": null,
        "isgovyear": true,
        "isactive": true
    });
    const [data, setData] = useState({ ...initData });
    const [checkReq, setCheckReq] = useState(false);
    const [loading, setLoading] = useState(false);

    const getExistsData = async () => {
        let tData = { ...initData };
        if (props.extratypeid) {
            setLoading(true);
            await API.get('/api/humanresource/payroll/get_extra_type?extratypeid=' + props.extratypeid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
            setLoading(false);
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.extratypeid])

    const fieldOnChanged = async (key, text, field) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            setData(tData);
        }
    }

    const onSave = async () => {
        let vRule = true;
        setCheckReq(true);
        if (!data.name) {
            vRule = false;
        }

        if (vRule) {
            await API.post('/api/humanresource/payroll/save_extra_type', [data]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    onDismiss();
                    props.afterSave();
                }
            });
        }
    }

    const onDelete = async () => {
        if (props.extratypeid) {
            await API.post('/api/humanresource/payroll/delete_extra_type?extratypeid=' + props.extratypeid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    onDismiss();
                    props.afterSave();
                }
            });
        }
    }

    const onDismiss = () => {
        setData({ ...initData });
        setCheckReq(false);
        props.onDismiss();
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                headerText={props.extratypeid ? 'Нэмэгдлийн төрөл засах' : 'Нэмэгдлийн төрөл нэмэх'}
                onDismiss={onDismiss}
                buttons={
                    <div style={{ display: 'flex' }}>
                        {props.extratypeid ? (
                            <div style={{ marginRight: 16 }}>
                                <ButtonSecondary text='Устгах' onClick={onDelete} />
                            </div>
                        ) : null}
                        <div>
                            <ButtonDefault text='Хадгалах' onClick={onSave} />
                        </div>
                    </div>
                }
            >
                <div style={{ marginTop: 25 }}>
                    <FieldText loading={loading} required onChanged={fieldOnChanged} title="Төрлийн нэр" keyfield='name' defaultValue={data.name} checkreq={checkReq} />
                    <div style={{ marginTop: 13 }}>
                        <FieldCheck onChanged={fieldOnChanged} title="Төрд ажилласан жилээр" keyfield='isgovyear' defaultValue={data.isgovyear} />
                    </div>
                    <div style={{ marginTop: 13 }}>
                        <FieldCheck onChanged={fieldOnChanged} title="Идэвхтэй" keyfield='isactive' defaultValue={data.isactive} />
                    </div>
                </div>
            </PanelBase>
        </div>
    );
}

export default ExtraTypeNew;